const floatiePlayAbi = [
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "_initialToken",
				"type": "address"
			},
			{
				"internalType": "contract IFloatieGateway",
				"name": "_gateway",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "contract IERC20",
				"name": "poolToken",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "enum FloatieLibrary.TransferType",
				"name": "poolType",
				"type": "uint8"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amountRewarded",
				"type": "uint256"
			}
		],
		"name": "BoostPoolRewarded",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "marketing",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "transferBoost",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "buyBoost",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "burnBoost",
				"type": "uint256"
			}
		],
		"name": "FeesUpdated",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "burnPool",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "buyPool",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "transferPool",
				"type": "uint256"
			}
		],
		"name": "PoolBalancesUpdated",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "poolID",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "chance",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "accuracy",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "rewardRate",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "fee",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "requiredAmount",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "threshold",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "coolDownTime",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "minimumHoldAmount",
				"type": "uint256"
			}
		],
		"name": "PoolSettingsUpdated",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "RocketTokensAdded",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amountRewarded",
				"type": "uint256"
			}
		],
		"name": "RocketTokensRewarded",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "transactionAmount",
				"type": "uint256"
			}
		],
		"name": "addRocketTokens",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "authorize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"internalType": "bool",
				"name": "enabled",
				"type": "bool"
			}
		],
		"name": "authorizeMember",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"internalType": "bool",
				"name": "enabled",
				"type": "bool"
			}
		],
		"name": "authorizeProjectMember",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "authorizedProjectMember",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "defaults",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "burnPoolID",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "buyPoolID",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "transferPoolID",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "stakingPoolID",
						"type": "uint256"
					}
				],
				"internalType": "struct DefaultPool",
				"name": "pools",
				"type": "tuple"
			},
			{
				"internalType": "uint256",
				"name": "holdAmount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "required",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "threshold",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "gateway",
		"outputs": [
			{
				"internalType": "contract IFloatieGateway",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			}
		],
		"name": "getDefaultPoolBalances",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "enum FloatieLibrary.TransferType",
				"name": "poolType",
				"type": "uint8"
			}
		],
		"name": "getPoolThreshold",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "_tokenReward",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "_holder",
				"type": "address"
			}
		],
		"name": "getUnpaidRewards",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getUserStats",
		"outputs": [
			{
				"internalType": "uint256[]",
				"name": "",
				"type": "uint256[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "chance",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "accuracy",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "rewardRate",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "requiredAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "threshold",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "coolDownTime",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "minimumHoldAmount",
						"type": "uint256"
					}
				],
				"internalType": "struct PoolSettings[4]",
				"name": "poolSettings",
				"type": "tuple[4]"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "transferBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "buyBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "burnBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "stakingBoost",
						"type": "uint256"
					}
				],
				"internalType": "struct Fees",
				"name": "fees",
				"type": "tuple"
			},
			{
				"internalType": "uint256",
				"name": "tokensPerRocketToken",
				"type": "uint256"
			},
			{
				"internalType": "address",
				"name": "_poolOwner",
				"type": "address"
			}
		],
		"name": "initializer",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "isAuthorized",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "isAuthorizedContract",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
		],
		"name": "isAuthorizedTeamMember",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "poolID",
				"type": "uint256"
			}
		],
		"name": "isInCoolDown",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "isOwner",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "_token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "recipient",
				"type": "address"
			},
			{
				"internalType": "enum FloatieLibrary.TransferType",
				"name": "_transferType",
				"type": "uint8"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "playFloatiePools",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "enum FloatieLibrary.TransferType",
				"name": "",
				"type": "uint8"
			}
		],
		"name": "playPlatform",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "total",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "lastRoll",
				"type": "uint256"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "chance",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "accuracy",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "rewardRate",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "requiredAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "threshold",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "coolDownTime",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "minimumHoldAmount",
						"type": "uint256"
					}
				],
				"internalType": "struct PoolSettings",
				"name": "poolSettings",
				"type": "tuple"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "previousWonAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "previousWinTime",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "previousWinner",
						"type": "address"
					}
				],
				"internalType": "struct WinnerInfo",
				"name": "winnerInfo",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "contract IERC20",
				"name": "",
				"type": "address"
			}
		],
		"name": "player",
		"outputs": [
			{
				"components": [
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "totalBurnPlays",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalBuyPlays",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalTransferPlays",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalStakingPlays",
								"type": "uint256"
							}
						],
						"internalType": "struct FloatieLibrary.FloatieCounter",
						"name": "counts",
						"type": "tuple"
					},
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "totalFundedBurn",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalFundedBuy",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalFundedTransfer",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalFundedStaking",
								"type": "uint256"
							}
						],
						"internalType": "struct FloatieLibrary.PoolsFunded",
						"name": "poolsFunded",
						"type": "tuple"
					},
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "totalWonBurnBoost",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalWonBuyBoost",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalWonTransferBoost",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalWonStakingBoost",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "lastTimeWonBurnPool",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "lastTimeWonBuyPool",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "lastTimeWonTransferPool",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "lastTimeWonStakingPool",
								"type": "uint256"
							}
						],
						"internalType": "struct FloatieLibrary.Winnings",
						"name": "winnings",
						"type": "tuple"
					},
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "totalSwapped",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalBurned",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalTransferred",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalStaked",
								"type": "uint256"
							}
						],
						"internalType": "struct FloatieLibrary.TxStats",
						"name": "txStats",
						"type": "tuple"
					},
					{
						"internalType": "uint256",
						"name": "multiplierTokens",
						"type": "uint256"
					}
				],
				"internalType": "struct FloatieLibrary.FloatiePlayer",
				"name": "data",
				"type": "tuple"
			},
			{
				"internalType": "uint256",
				"name": "rewardBalances",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "_stakingBoost",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_transferBoost",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_buyBoost",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_burnBoost",
				"type": "uint256"
			}
		],
		"name": "setFees",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_rocketContract",
				"type": "address"
			},
			{
				"internalType": "bool",
				"name": "enabled",
				"type": "bool"
			}
		],
		"name": "setRocketContract",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "bool",
				"name": "_rocketTokensCapped",
				"type": "bool"
			}
		],
		"name": "setRocketTokensCapped",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "syncDeposit",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "",
				"type": "address"
			}
		],
		"name": "tokenData",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "transferBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "buyBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "burnBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "stakingBoost",
						"type": "uint256"
					}
				],
				"internalType": "struct Fees",
				"name": "fees",
				"type": "tuple"
			},
			{
				"components": [
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "burnPoolID",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "buyPoolID",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "transferPoolID",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "stakingPoolID",
								"type": "uint256"
							}
						],
						"internalType": "struct DefaultPool",
						"name": "pools",
						"type": "tuple"
					},
					{
						"internalType": "uint256",
						"name": "holdAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "required",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "threshold",
						"type": "uint256"
					}
				],
				"internalType": "struct Defaults",
				"name": "defaults",
				"type": "tuple"
			},
			{
				"internalType": "bool",
				"name": "isInitialized",
				"type": "bool"
			},
			{
				"internalType": "address",
				"name": "poolInitiator",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokensPerRocketToken",
				"type": "uint256"
			},
			{
				"internalType": "bool",
				"name": "rocketTokensCapped",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address payable",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "unauthorize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "updateDividend",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenAmount",
				"type": "uint256"
			},
			{
				"internalType": "enum FloatieLibrary.TransferType",
				"name": "poolType",
				"type": "uint8"
			}
		],
		"name": "updatePool",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "poolID",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "chance",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "accuracy",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "rewardRate",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "requiredAmount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "threshold",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "coolDownTime",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minimumHoldAmount",
				"type": "uint256"
			}
		],
		"name": "updatePoolSettings",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "updatePools",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "enum FloatieLibrary.TransferType",
				"name": "poolType",
				"type": "uint8"
			}
		],
		"name": "validatePool",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "chance",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "accuracy",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "rewardRate",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "requiredAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "threshold",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "coolDownTime",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "minimumHoldAmount",
						"type": "uint256"
					}
				],
				"internalType": "struct PoolSettings",
				"name": "poolSettings",
				"type": "tuple"
			}
		],
		"name": "validatePoolSettings",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"stateMutability": "payable",
		"type": "receive"
	}
];

export default floatiePlayAbi;